import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { EazyworksPatientsRoute } from 'routes';
import { EazyworkPatientDetailsRoute, EazyworkPatientImportRoute, EazyworksKlantenListPage } from './eazyworks-klanten-list.page';
import { EazyworkKlantDetailPage } from './eazywork-klant-detail.page';
import { ImportEazyworkKlantPage } from './import-eazywork-klant.page';

export const EazyworksDataSwitch = () => {
	return (
		<Switch>
			<Route
				exact
				path={EazyworksPatientsRoute}
				component={EazyworksKlantenListPage}
			/>
			<Route
				exact
				path={EazyworkPatientImportRoute}
				component={ImportEazyworkKlantPage}
			/>
			<Route
				exact
				path={EazyworkPatientDetailsRoute}
				component={EazyworkKlantDetailPage}
			/>
			<Redirect to={EazyworksPatientsRoute} />
		</Switch>
	);
};
